<!-- eslint-disable vue/no-mutating-props -->
<template>
  <!-- :format="format" doesn't work because we use a template -->
    <v-date-input
        locale="fr"
        input-format="dd/mm/yyyy"
        prepend-icon=""
        :model-value="filter.value"
        :min="filter.min || null"
        :max="filter.max || null"
        persistent-hint
        :display-format="(val) => formatForDisplay(val)"
        :aria-label="filter.translation || $translate(`${translationName}.${filter.name}`)"
        :label="filter.translation || $translate(`${translationName}.${filter.name}`)"
        class="filters-input pb-0"
        clearable
        variant="solo"
        @click:clear="$emit('updateFilters', null)"
        @update:model-value="$emit('updateFilters', getDateFormat($event))"
    ></v-date-input>
<!--  <VueDatePicker-->
<!--    v-model="filter.value"-->
<!--    :enable-time-picker="false"-->
<!--    :min-date="filter.min || null"-->
<!--    :max-date="filter.max || null"-->
<!--    position="center"-->
<!--    class="custom-input"-->
<!--    locale="fr"-->
<!--    auto-apply-->
<!--    :teleport="true"-->
<!--    hide-input-icon-->
<!--    @update:model-value="$emit('updateFilters', getDateFormat($event))"-->
<!--  >-->
<!--    <template #trigger>-->
<!--      <v-text-field-->
<!--        v-model="valueShown"-->
<!--        :aria-label="filter.translation || $translate(`${translationName}.${filter.name}`)"-->
<!--        :label="filter.translation || $translate(`${translationName}.${filter.name}`)"-->
<!--        class="filters-input pb-0"-->
<!--        clearable-->
<!--        variant="solo"-->
<!--        @click:clear="$emit('updateFilters', null)"-->
<!--      />-->
<!--    </template>-->
<!--  </VueDatePicker>-->
</template>
<script lang="ts">
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment'

export default {
    name : "DateFilter",
    components : {VueDatePicker},
    props: {
        translationName: { type: String, required: true },
        filter: { type: Object, required: true },
    },
    emits: ['updateFilters', 'updateFilterState'],
    data () {
        return {
            moment
        }
    },
    computed: {
      valueShown: {
        get() {
          return this.format(this.filter.value)
        },
      }
    },
    methods : {
        formatForDisplay() {
            return this.format(this.filter.value)
        },
        format (date) {
            return this.$formatDate(date)
        },
        getDateFormat (date) {
            return date ? moment(date).utc(1).format('YYYY-MM-DD') : null
        },
    }
}
</script>
